import { useEffect, useRef, useState } from "react";

export function useVirtualScrollDummyCard(
    scrollTop: number,
    scrollableContainerHeight: number,
    showMargin: number, // ぎりぎりの要素しか表示しないのではなく、少し上下に余裕を持たせて表示する
    index: number // スクロール以外の要因で並び順・位置が変わったときのため
) {
    const cardRef = useRef<HTMLDivElement>(null);
    const [isDummyCard, setIsDummyCard] = useState(true);
    useEffect(() => {
        const offsetTop = cardRef.current?.offsetTop;
        setIsDummyCard(
            !offsetTop ||
                scrollTop > offsetTop + showMargin ||
                scrollTop < offsetTop - scrollableContainerHeight - showMargin
        );
    }, [scrollTop, index]);

    return { cardRef, isDummyCard };
}
